// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
import { isWeiXin } from '@/common/ts/common';
// 活动api baseurl
const urlPrefix = '/vote/2021project/q1/2021nature/controller.php?enews=';

const BG_IMAGES: { [key: string]: any } = {
  spring: require('../assets/1-1.png'),
  summer: require('../assets/标题.png'),
  autumn: require('../assets/3-1.png'),
  winter: require('../assets/4-1.png'),
};

const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getVoteList = (
  type: number,
  season: string,
  page: number,
  keyword?: string,
) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      workType: type,
      season,
      page,
      search: keyword,
    },
  });
};
const getDetail = (id: any) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};

const getAreas = (type: string) => {
  return http.get(`${urlPrefix}getAreas`, {
    params: {
      type,
    },
  });
};

const getSummerType = () => {
  return http.get(`${urlPrefix}getSummerWorkType`);
};

const getSchools = (search: any) => {
  return http.get(`${urlPrefix}getSchools`, {
    params: {
      search,
    },
  });
};
const save = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}save`, qsData);
};

const share = (context: any) => {
  context.$appShareInfo({
    title: '渝港澳青少年自然探索大赛',
    url: location.href,
    subtitle: '走进四季，爱上万物。春知花-夏知草-秋知树-冬知药。',
    classId: -1,
    id: -1,
    type: 3,
  });
  // 微信分享
  if (isWeiXin()) {
    context.$wxShareInfo({
      title: '渝港澳青少年自然探索大赛',
      subtitle: '走进四季，爱上万物。春知花-夏知草-秋知树-冬知药。',
    });
  }
};
const springRule = () => {
  const data = `<div class="cqcb-title-sm" style="white-space: normal;">
    <h3>欢迎参加渝港澳青少年百花摄影大赛</h3>
</div>

<p class="riles_state" style="white-space: normal;">
    &nbsp; &nbsp;
 &nbsp;春天是万物复苏，生机勃勃的季节，为给渝港澳青少年的成长留下一路芬芳，为花样年华烙下美好印记，特邀渝港澳青少年参加“渝港澳青少年百花摄影大赛”。</p >
   <p class="riles_state" style="white-space: normal;">
    &nbsp; &nbsp;
 &nbsp; 繁花盛世，春摄满园！</p >
<div class="cqcb-title-sm" style="white-space: normal;">
    <h3>一、活动时间 </h3>
</div>
 <p class="riles_state" style="white-space: normal;">
    &nbsp; &nbsp;
 &nbsp; 2021年1月至2021年5月31日</p >
<div class="cqcb-title-sm" style="white-space: normal;">
    <h3>二、活动组织 </h3>
<div class="cqcb-title-sm" style="white-space: normal;">
    <h4>（一）主办单位</h4>
 <p class="riles_state" style="white-space: normal;">
    &nbsp; &nbsp;
   &nbsp;重庆方：市政府港澳办、市政府新闻办、市教委、市城市管理局、市文化旅游委、市林业局<br/>
港澳方：香港教联会、渝澳联谊总会、渝港台青年交流促进会、香港内地学生联合总会等港澳地区相关机构和社会团体</p >
<div class="cqcb-title-sm" style="white-space: normal;">
    <h4>（二）承办单位</h4>
 <p class="riles_state" style="white-space: normal;">
    &nbsp; &nbsp;
   &nbsp;重庆方：渝中区委宣传部、渝中区政府外办、渝中区政府新闻办、渝中区教委、渝中区城市管理局、渝中区文化旅游委、重庆市南山植物园、重庆市人民小学教育集团、重庆国际传播中心、上游新闻<br/>
港澳方：有关学校、企业、社会团体和媒体</p >
<div class="cqcb-title-sm" style="white-space: normal;">
    <h3>三、活动对象</h3>
 <p class="riles_state" style="white-space: normal;">
    &nbsp; &nbsp;
   &nbsp;香港特别行政区、澳门特别行政区、重庆市各大中小学校在校学生、在渝港澳机构人员学龄子女</p >
<div class="cqcb-title-sm" style="white-space: normal;">
    <h3>四、活动内容</h3>
 <p class="riles_state" style="white-space: normal;">
    &nbsp; &nbsp;
   &nbsp;让渝港澳青少年在百花盛开的春季，走进自然，用手机或相机拍摄家乡、故乡、原乡、他乡的各种花卉，通过拍百花表达乡愁，并通过线上线下多种形式的交流活动，增进渝港澳青少年文化和情感交流，培养敬爱自然、珍爱生命、热爱祖国的美好情怀。<br/>
参赛选手将拍摄的花卉照片和个人对所拍花卉的理解认识写一段感言，一起上传至大赛线上平台专题展示参赛。获奖作品在主办方合作的海内外媒体平台推送展示。</p >
<div class="cqcb-title-sm" style="white-space: normal;">
    <h3>五、作品要求</h3>
 <p class="riles_state" style="white-space: normal;">
（一）参赛摄影作品为花卉题材，展现大自然的美好及花卉植物的千姿百态，主题鲜明，内容健康积极向上。<br/>
（二）比赛采用电子投稿，作品为新近拍摄，不使用过往作品，参赛摄影作品须为JPG格式，不小于3M不超过5M。<br/>
（三）参赛摄影作品可以为单幅，也可以为一组（不超过4幅）紧密关联的系列作品，彩色、黑白不限，真实记录不得合成（仅可作亮度、对比度和色彩饱和度适度调整）。<br/>
（四）参赛作品上传请根据大赛网络平台操作步骤完整真实填写参赛报名资料，附注的拍摄说明及对所拍花卉的理解认识感言，作为作品评审参考。</p >
<div class="cqcb-title-sm" style="white-space: normal;">
    <h3>六、赛区及组别设置</h3>
<p class="riles_state" style="white-space: normal;">
    &nbsp; &nbsp;
   &nbsp;大赛设置重庆赛区、香港赛区和澳门赛区，设小学组、中学组和大学组三个比赛组别。各赛区分别开展作品征集及初赛评审，评选出三个比赛组别共750幅入围决赛作品（重庆赛区450幅、香港赛区150幅、澳门赛区150幅），参加网络展示及决赛评审。</p >
<div class="cqcb-title-sm" style="white-space: normal;">
    <h3>七、比赛安排</h3>
<p class="riles_state" style="white-space: normal;">
    &nbsp; &nbsp;
   &nbsp;（一）报名参赛。参赛选手在2021年4月30日前，重庆赛区登录上游新闻大赛线上平台（香港赛区及澳门赛区另定）填写网络报名表，并上传参赛作品。<br/>
（二）线上展示。渝港澳三地赛区组委会将组织初赛评审会，入围决赛环节作品将集中在重庆上游新闻和港澳媒体大赛线上平台进行专题展示，通过网友点赞评选出最佳网络人气奖。<br/>
（三）决赛评审。大赛组委会组织决赛评审会，评选出金银铜奖、优秀作品奖等奖项。<br/>
（四）颁奖仪式。2021年5月下旬在重庆举办，对渝港澳三地获奖选手代表进行现场颁奖，具体时间待定。<br/>
（五）作品巡展。重庆赛区在南山植物园（港澳赛区待定）进行获奖作品展示，然后在部分区县进行巡展。</p >
<div class="cqcb-title-sm" style="white-space: normal;">
    <h3>八、奖项设置</h3>
<p class="riles_state" style="white-space: normal;">
（一）奖项数量：设置金奖10名、银奖30名、铜奖60名，优秀作品奖100名，网络人气奖100名，杰出指导老师50名。<br/>
（二）奖励办法：向所有获奖选手颁发荣誉证书。重庆赛区获奖者可在重庆市南山植物园认领或种植（开辟一个种植区）代言花卉，港澳地区该奖励办法根据实际情况另行制定。</p >
<div class="cqcb-title-sm" style="white-space: normal;">
    <h3>九、其它事项</h3>
<p class="riles_state" style="white-space: normal;">（一）各赛区、各高校、各区县要积极发动大中小学生参加比赛，组织老师和家长做好学生作品创作指导和参赛报名工作。<br/>
（二）投稿作品须为原创且未发表，否则因作品的版权及著作权纠纷产生的责任由作者本人承担。<br/>
（三）所有参赛作品可能被主办单位上传至相关大赛网页或宣传刊物中作活动或相关公益活动宣传用途，主办单位享有使用该作品的权利，无需再征得作者同意，亦不支付稿酬。<br/>
（四）主办单位对本次大赛享有最终解释权。<br/>
（五）活动联系：13667641151（江老师）。</p >`;
  return data;
};

const summerRule = () => {
  return `<h3>夏知草·渝港澳青少年笔记本大赛
最佳网络人气奖评选活动</h3>
<p>1、进行网上展示作品为"夏知草·渝港澳青少年笔记本大赛"重庆、香港、澳门三个赛区入围总决赛作品，活动将根据作品的网络点击量排名选出“最佳网络人气奖”，由组委会颁发获奖证书。</p>
<p>2、网络展示时间：2021年11月10日00:00至11月20日00:00结束。</p>
<p>3、鼓励参赛者通过转发扩散作品以提升自身作品人气，但严禁通过不正当手段刷票。</p>
<p>4、本次活动在作品本身评审之外开展，旨在给参赛者提供展示作品风采的机会，网络数据不影响金银铜奖评审结果。</p>
<p>5、大赛组委会对活动享有最终解释权。</p>`;
};
export {
  getBaseInfo,
  share,
  getRule,
  getVoteList,
  getDetail,
  getAreas,
  getSchools,
  save,
  springRule,
  getSummerType,
  summerRule,
  BG_IMAGES,
};
